// assets
import { IconFileDescription } from '@tabler/icons-react';

// constant
const icons = {
    IconFileDescription
};

// ==============================|| SERVICE MENU ITEMS ||============================== //

const clinical = {
    id: 'clinical',
    title: '임상 진행',
    type: 'group',
    children: [
        {
            id: 'clinical_management',
            title: '대상자 전체목록',
            type: 'item',
            url: '/service/clinical',
            icon: icons.IconFileDescription,
            breadcrumbs: true,
            children: [
                {
                    id: 'clinical_detail',
                    title: '대상자 어노테이션 상세 조회',
                    type: 'item',
                    url: '/service/clinical/:id',
                    icon: icons.IconContract,
                    breadcrumbs: true
                },
                {
                    id: 'clinical_register',
                    title: '대상자 신규 등록',
                    type: 'item',
                    url: '/service/clinical/register',
                    icon: icons.IconContract,
                    breadcrumbs: true
                }
            ]
        }
    ]
};

export default clinical;
